module.exports = __webpack_public_path__ + "media/honey-icons/icon-tone-34420d57.svg";